import { Component, OnInit, Input } from "@angular/core";
import firebase from "firebase";
import {Account} from "../../../../models/account.model";

@Component({
  selector: "app-card-exit",
  templateUrl: "./card-exit.component.html",
})
export class CardExitComponent implements OnInit {

  activeExitSession: number = 0;
  account: Account;

  constructor() {
    this.account = JSON.parse(localStorage.getItem('account'));
    this.getCountLogsExit().then();
  }

  async ngOnInit() {
    await this.getCountLogsExit();
  }

  getStartOfToday() {
    const now = new Date();
    now.setHours(0, 0, 0, 0); // +5 hours for Eastern Time
    return firebase.firestore.Timestamp.fromDate(now);
  }

  async getCountLogsExit(){

    const query = firebase.firestore().collection('logs');
    const observer = query
      .where('account_key', '==', this.account.account_key)
      .where('status', '==', 'completed')
      .where('timestamp', '>=', this.getStartOfToday())
      .onSnapshot(querySnapshot => {
      console.log(`Received query snapshot of exit getStartOfToday size ${querySnapshot.size}`);
      this.activeExitSession = querySnapshot.size;
    }, err => {
      console.log(`Encountered error: ${err}`);
    });

  }

}
